/**
 * App icon — the mark inset into a rounded paper-color tile. Used for the
 * homepage hero, navbar logo, admin login, loading splash, and PWA manifest.
 *
 * Geometry matches the brand preview's 512x512 app-icon variant exactly.
 */
interface Props {
  className?: string;
  /** Background tile color. Default: paper #F7F3EA. */
  bg?: string;
  /** Mark fill color. Default: brand teal #3D8C84. */
  fg?: string;
  /** When provided, rendered as `role="img"`. Otherwise aria-hidden. */
  title?: string;
}

export function LogoIcon({
  className,
  bg = "#F7F3EA",
  fg = "#3D8C84",
  title,
}: Props) {
  return (
    <svg
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role={title ? "img" : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
    >
      <rect width="512" height="512" rx="96" fill={bg} />
      <g fill={fg}>
        <rect x="131" y="130" width="40" height="50" />
        <rect x="137" y="110" width="28" height="20" />
        <path d="M 139 110 L 151 84 L 163 110 Z" />
        <circle cx="151" cy="76" r="4" />
        <path
          fillRule="evenodd"
          d="M 80 400 L 80 180 L 432 180 L 432 400 Z M 116 400 L 116 304 Q 116 290 125 286 L 135 264 L 142 274 L 151 240 L 160 274 L 167 264 L 177 286 Q 186 290 186 304 L 186 400 Z M 222 400 L 222 304 Q 222 290 231 286 L 241 264 L 248 274 L 257 240 L 266 274 L 273 264 L 283 286 Q 292 290 292 304 L 292 400 Z M 328 400 L 328 304 Q 328 290 337 286 L 347 264 L 354 274 L 363 240 L 372 274 L 379 264 L 389 286 Q 398 290 398 304 L 398 400 Z"
        />
      </g>
    </svg>
  );
}
